import {CountTriggerTextViewerCoreOption} from '../type/CountTriggerTextViewerCoreOption.interface';

export function getScrollTextViewerSizes({
  size: {width},
  margin,
}: CountTriggerTextViewerCoreOption) {
  const contentMargin = margin;
  const containerWidth = width - contentMargin * 2;
  const contentWidth = containerWidth;

  return {
    contentMargin,
    containerWidth,
    contentWidth,
  };
}
